
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as testWAmRdgC_JsMpRTj2Lw1hcgaT_45NU9xgELwBJuztcYPh8Meta } from "/app/pages/test.vue?macro=true";
import { default as errormwD7kY_45BU1_rHGEshIkO6bNB5B0luZiwF4k9TLpjX_45IMeta } from "/app/pages/error.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91key_93BuuzDMVPlWF7zvM8ZwYT4CN8oyyxiIKMQncSKEgfztsMeta } from "/app/pages/group/[key].vue?macro=true";
import { default as _91role_93oyiar0M5XdEbIGseGUVndM6i2n9G5XfG5qqPOeTXw_wMeta } from "/app/pages/rooms/[key]/[role].vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    component: () => import("/app/pages/test.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "group-key",
    path: "/group/:key()",
    component: () => import("/app/pages/group/[key].vue")
  },
  {
    name: "rooms-key-role",
    path: "/rooms/:key()/:role()",
    component: () => import("/app/pages/rooms/[key]/[role].vue")
  }
]